import { useEffect } from "react";


const WelcomeOverlay = ({ onComplete }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 5000); // 7 seconds

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="session-overlay" style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      backdropFilter: "blur(5.5px)",
      alignItems: "center",
      zIndex: 9998,
      background: "rgba(53, 66, 88, 0.84)",
    }}>
      <div >
      <div className="d-flex justify-content-center">
        <img src="/assets/images/welcome.gif" alt="Flash" className="w-450px" />
      </div>
      <div className="position-fixed h-100 w-100 top-0px">
        <div className="d-flex align-items-center position-relative h-100">
          <img src="/assets/images/wizardwhitelogo.png" alt="Logo" style={{ width: "380px" }} />
        </div>
      </div>
    </div>
    </div>
  );
};

export default WelcomeOverlay;